<template>
  <v-layout row wrap>
    <v-flex xs12 md4 lg3>
      <v-layout column>
        <v-flex ma-2>
          <FCCRaceDetails />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md8 lg9>
      <v-layout column>
        <v-flex ma-2>
          <FCCRaceRuns />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    VTextField,
    VDataTable,
    VTooltip,
  } from 'vuetify/lib'
  import FCCRaceDetails from '../components/race/FCCRaceDetails'
  import FCCRaceRuns from '../components/race/FCCRaceRuns'
  import fccapi from '../fccapi.js'

  export default {
    name: 'Race',
    data: () => ({
      search: "",
      headers: [
        { text: 'competition', value: 'competition' },
        { text: 'title', value: 'title' },
        { text: 'type', value: 'type' },
        { text: 'category', value: 'category' }
      ],
      items: []
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      }
    },
    props: {
      source: String
    },
    components: {
      VDataTable,
      VTextField,
      VTooltip,
      FCCRaceDetails,
      FCCRaceRuns,
    },
    mounted() {
      
    }
  }
</script>